import ProductCards from 'components/ProductCards/index';
import Banner from 'components/Banner';
import './styles.scss';
import { data } from './mockdata';
import GradientText from 'components/GradientText';
import image from 'images/small-images-inside-text/Image.jpg';
import productsBanner from 'images/productsBanner.jpg';

const Products = () => {
    return (
        <div className="products-page">
            <div className="container">
                <Banner title="Our products" image={productsBanner} buttonText="VIEW PRODUCTS" />
                <GradientText>
                    We pride ourselves on providing a wide range of
                    <img src={image} alt="decor" />
                    <em>high-quality agricultural solutions</em> to meet your specific needs.
                </GradientText>
                <div className="offset-left-4 max-width-760">
                    <GradientText size="small">
                        Our product line is created to{' '}
                        <em>
                            ensure sustainable growth <br />
                            and increased yields.
                        </em>
                    </GradientText>
                </div>
                <ProductCards data={data} />
            </div>
        </div>
    );
};

export default Products;
